import styled from 'styled-components'
import { colors } from '../../const'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1380px;
  padding: 1% 2%;
  width: 100%;
`

export const ReportWrapper = styled.section`
  align-items: stretch;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 100%;

  @media screen and (max-width: 1280px) {
    flex-direction: column;
  }
`

export const CaseId = styled.section`
  color: ${colors.textSecondary};
  font-family: 'Roboto';
  font-size: 1.5rem;
  font-weight: 700;
  margin: 14px 0 22px;
`

export const ReadOnlyMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  text-align: center;
  padding: 2rem;
  background-color: ${colors.surface};
  border-radius: 8px;
  border: 1px solid ${colors.borderSubtle};
  color: ${colors.textSecondary};
  font-size: 1.125rem;
  width: 45%;
  max-width: 45%;
  box-sizing: border-box;
  height: auto;
  min-height: 400px;
  
  @media screen and (max-width: 1280px) {
    width: 100%;
    max-width: 100%;
    min-height: 200px;
  }
`
